export const SET_VERSION = 'SET_VERSION'

export const setVersion = data => async dispatch => {
  dispatch({
    type: SET_VERSION,
    payload: data
  })
}